import React, { Component } from "react";
import { withStyles, styled } from "@material-ui/core/styles";
import Modal from "@mui/material/Modal";
import { Input, Button, Table, message, Tooltip,  Modal as AntdModal, } from 'antd';
import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons'
import FormControlLabel from "@mui/material/FormControlLabel"; 
import Switch from "@mui/material/Switch";
import { withRouter } from "react-router-dom";
import LabelModal from "../common/LabelModal"; 
import SettingModal from "../common/SettingModal";
import { Tour } from 'antd-v5'
import axios from 'axios'
const { confirm } = AntdModal;
import {
  getSubscribeList,
  getUserInfo,
  editUserInfo,
  updateUserInfo,
  addSubscribeLabel,
  deleteSubscribeLabel,
  collectFile,
  cancelCollectFile,
  delelteFileLabel,
  addLabelToFile,
  addCollectLabel,
  emailPushSettingDetail
} from "../../actions/subscribe";
import { searchFileList } from "../../actions/index"
import InfiniteScroll from "react-infinite-scroll-component";

import {
  getLabelId,
  getUserSubscribeLabelId,
  getCollectId,
  getUserFileLabelList,
  getFileLabelId,
} from "../../utils/common";
import store from "../../store";
import { aliases } from "browserslist";

const styles = () => {
  return {
    root: {
      width: "100%",
      height: "100%",
      padding: "10px",
      display: 'flex',
      flexDirection: 'column',
      boxSizing: "border-box"
    },
    topBar: {
      width: "100%",
      padding: "10px 20px",
      marginBottom: "10px",
      background: "#FFFFFF",
      boxShadow: "0px 1px 5px 1px rgba(0, 0, 0, 0.1)",
      borderRadius: "5px",
      fontSize: '16px',
      color: '#333'
    },
    main: {
      flex: 1,
      width: "100%",
      height: "1px",
      display: 'flex',
      overflow: 'hidden'
    },
    leftTable: {
      flex: 1,
      width: '1px',
      height: "100%",
      backgroundColor: "#fff",
      boxShadow: "0px 1px 5px 1px rgba(0, 0, 0, 0.1)",
      borderRadius: "5px",
      overflow: 'auto'
    },
    rightForm: {
      position: 'relative',
      display: 'block !important',
      width: "300px",
      height: "100%",
      marginLeft: "10px",
      backgroundColor: "#fff",
      boxShadow: "0px 1px 5px 1px rgba(0, 0, 0, 0.1)",
      borderRadius: "5px",
      transition: 'all linear .3s',
    },
    hideSearch: {
      width: 0,
      marginLeft: "0px",
      transition: 'all linear .3s'
    },
    tableOuter: {
      padding: '0 !important',
      margin: '0 !important'
    },
    topTab: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 20px'
    },
    line: {
      height: "25px",
      fontSize: "14px",
      color: "#000",
      display: "flex",
      alignItems: "center",
    },
    title: {
      marginRight: "10px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "#5F6876",
    },
    total: {
      color: "#F04C35",
    },
    inputGroup: {
      marginTop: "12px",
    },
    input: {
      width: "535px",
      height: "40px",
      borderRadius: "0",
      marginRight: "20px",
      "& fieldset": {
        borderWidth: "1px !important",
      },
      "& .MuiInputBase-root": {
        borderRadius: "0",
      },
    },
    btn: {
      width: "70px",
      height: "40px",
      background: "#0F25D1 !important",
      borderRadius: "2px !important",
    },
    container: {
      padding: "0 20px 20px",
    },
    list: {
      width: "1px",
      paddingRight: "16px",
    },
    label: {
      marginBottom: "16px",
    },
    labelContainer: {
      marginTop: "40px"
    },
    labelTitle: {
      display: "flex",
      justifyContent: "space-between",
    },
    titleLeft: {
      display: "flex",
      alignItems: "center",
      color: "#42BD57",
      fontSize: "18px",
      fontWeight: "bold",
    },
    switch: {
      width: "68px !important",
      height: "22px !important",
      padding: "0 12px !important",
      "& .MuiSwitch-track": {
        width: "44px",
        height: "22px",
        borderRadius: "11px",
      },
      "& .MuiSwitch-switchBase": {
        padding: "0",
        "&:hover": {
          background: "none",
        },
        "&.Mui-checked+.MuiSwitch-track": {
          backgroundColor: "#3DBD7D",
        },
        "& .MuiTouchRipple-root": {
          background: "#fff",
          transform: "translate(14px, 1px)",
        },
        "& .MuiSwitch-thumb": {
          background: "#fff",
          transform: "translate(14px, 1px)",
        },
      },
    },
    switchLabel: {
      marginLeft: '8px !important',
      "& .MuiFormControlLabel-label": {
        fontSize: "14px",
        fontWeight: "bold",
        color: "#5F6876",
      },
    },
    subTitle: {
      margin: "20px 0 16px",
      lineHeight: "22px",
      fontSize: "16px",
      color: "#4A4A4A",
      fontWeight: "bold",
    },
    tag: {
      height: "22px",
      margin: "0 10px 10px 0",
      lineHeight: "22px",
      fontSize: "14px",
      color: "#000",
      fontWeight: "400",
      padding: "0 12px",
      display: "inline-block",
      border: "1px solid #E9E9E9",
      borderRadius: "4px",
      cursor: "pointer",
      "&.active": {
        color: "#07AEA0",
        borderColor: "#07AEA0",
      },
    },
    popover: {
      display: 'flex',
      alignItems: 'center'
    },
    clearMargin: {
      margin: '0 !important'
    },
    textBtn: {
      color: '#444',
      padding: '0 5px',
      "&:hover": {
        color: '#1890ff !important'
      }
    },
    tabTop: {
      height: "20px"
    },
    linkText: {
      color: '#333',
      '&:hover': {
        color: '#333',
        textDecoration: 'underline'
      }
    },
    slideIcon: {
      cursor: 'pointer',
    },
  };
};

class Subscribe extends Component {
  constructor(props) {
    super(props);
    this.ref2 = React.createRef(null);
    this.ref3 = React.createRef(null);
    this.ref4 = React.createRef(null);
  }

  state = {  
    tourKey: 0,
    tourCurrent: 0,
    openTour: false,
    beginner_index: 0,
    keyword: "",
    error: "",
    page: 1,
    is_all: 0,
    count: 0,
    userId: "", //用户id
    username: "", //用户名
    userEmail: "",
    modalTitle: "",
    openMessage: "",
    dataId: "",
    fileTotal: 0,
    errorMessage: "",
    push: true,
    openModal: false,
    openSetting: false,
    isFirst: true,
    showSearch: true,
    fileList: [],
    labelList: [],
    allLabelList: [],
    labelArr: [],
    tagArr: [],
    lable_content: "",
    collectFileId: [],
    columns: [],
    loading: false,
    showTab: false,
    data: [],
    tabIndex: 0,
    fileType: "",
    parent_lable_id: "",
    tabList: [
      {
        title: '法律法规',
        type: '法律法规'
      },
      {
        title: '法规',
        type: '法规'
      },
      {
        title: '标准',
        type: '标准'
      },
      {
        title: '指导原则',
        type: '指导原则'
      },
    ],
    form: {

    },
    paginationObj: {
      showSizeChanger: true,
      total: 0,
      showTotal: (total, range) => {
        return '共【' + this.state.paginationObj.total + '】条'
      },
      onChange: (page, pageSize) => {
        this.pageChange(page, pageSize)
      },
    },
    scrollObj: {}
  };

  componentDidMount() {
    


    let pathname = this.props.location.pathname;
    let fileType = "";
    let showTab = false
    let parent_lable_id = ""
    switch (pathname) {
      case "/userCenter/subscribeLaw":
        fileType = "法律法规";
        showTab = true
        parent_lable_id = 1
        break;
      case "/userCenter/subscribeFDA":
        fileType = "海外法规";
        showTab = false
        parent_lable_id = 2
        break;
    }
    this.setState(
      {
        username: store.getState().auth.username,
        fileType: fileType,
        showTab: showTab,
        parent_lable_id: parent_lable_id
      },
      () => {
        this.getColumns()
        this.queryUserInfo()
      }
    );

  }

  //查询用户信息
  queryUserInfo = () => {
    getUserInfo({ username: this.state.username }).then((res) => {
      if (res.results && res.results.length > 0) {
        let userData = res.results.filter((v) => {
          return v.username == this.state.username;
        })[0];
        if (userData) {
          let index = userData.beginner_index
          let openTour = index != 5 && index != 7
          this.setState(
            {
              userId: userData.id,
              labelList: userData.subscribe_lables,
              push: userData.is_email_pushed,
              userEmail: userData.email,
              collectFileId: userData.favorite_basefiles.map((v) => {
                return v.basefile_id;
              }),
              openTour: openTour,
              beginner_index: index
            },
            () => this.loadMore()
          );
        }
      }

      if (res.results && res.results.length > 0) {
      }
    });
  };



  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  handlePreview = (url) => {
    const w = window.open("ablut:blank");
    localStorage.setItem("file_url", url);
    w.location.href = "/viewer";
  };
  //收藏文件
  handCollect = (id) => {
    this.setState({
      openModal: true,
      modalTitle: "文件收藏",
      dataId: id,
      tagArr: [],
    });
    //收藏文件
    collectFile({
      base_file: id,
      user: this.state.userId,
    });
  };
  //取消收藏
  handCancelCollect = (id) => {
    getCollectId(id, this.state.userId).then((collectId) => {
      cancelCollectFile(collectId).then((res) => {
        if (res && res.message) {
          message.warning(res.message)
        } else {
          message.success('取消成功')
          this.queryUserInfo();
        }
      });
    });
  };

  loadMore = () => {
    const param = {
      keyword: this.state.form.keyword,
      file_category_type: this.state.fileType,
      lable_content: this.state.lable_content,
      search_type: '订阅',
      ...this.state.page
    };
    this.setState({
      loading: true
    })
    searchFileList(param).then((res) => {
      if (res && res.result) {
        let data = res.result
        let newPaginationObj = this.state.paginationObj
        newPaginationObj.total = res.count
        let allLabelList = res.subscribe_file_lable_count.map((v, i) => {
          if (i == 0) {
            return { 
              lable_content: "全部",
              count: v['全部'],
              lable_id: ""
            }
          } else {
            return {
              lable_content: v.lable_content,
              count: v.lable_file_count,
              lable_id: v.lable_id
            }
          }
        })
        this.setState({
          data: data,
          paginationObj: newPaginationObj,
          allLabelList: allLabelList,
          loading: false
        });
      } else {
        this.setState({
          loading: false
        })
      }
    });
  };

 

  changePush = () => {
    if (this.state.push) {
      updateUserInfo({ is_email_pushed: false }, this.state.userId);
    }
    this.setState(
      {
        openSetting: !this.state.push,
        push: !this.state.push,
      }
    );
  };

  handleSavePushSetting = () => {
    this.setState({
      openSetting: false
    })
    updateUserInfo({ is_email_pushed: this.state.push }, this.state.userId);
  }

  //选择收藏标签
  changeLabel = (tag) => {
    let newTag = "";
    if (this.state.lable_content != tag) {
      newTag = tag;
    }
    if (newTag == '全部') {
      newTag = ''
    }
    this.setState(
      {
        lable_content: newTag,
      },
      () => this.loadMore(true)
    );
  };
  //管理标签
  handSetting = (id) => {
    getUserFileLabelList(id, this.state.userId).then((list) => {
      this.setState({
        openModal: true,
        dataId: id,
        modalTitle: "管理标签",
        tagArr: list,
      });
    });
  };
  //关闭弹框
  handleClose = () => {
    this.setState({
      openModal: false,
    });
    this.queryUserInfo();
  };

  handleCloseSetting = () => {
    this.setState({
      openSetting: false,
      push: false
    });
    updateUserInfo({ is_email_pushed: false }, this.state.userId);
  };

  showModal = () => {
    this.setState({
      openModal: true,
      modalTitle: "管理订阅",
      tagArr: [].concat(this.state.labelList),
    });
  };
  handRemove = (id) => {
    if (this.state.modalTitle == "管理订阅") {
      getUserSubscribeLabelId(this.state.userId, id).then((labelId) => {
        deleteSubscribeLabel(labelId).then(() => {
          this.setState(
            {
              isFirst: true,
            },
            () => this.queryUserInfo()
          );
        });
      });

      let tagList = [].concat(this.state.labelList);
      let index = tagList.findIndex((v) => {
        return v.lable_id == id;
      });
      tagList.splice(index, 1);
      this.setState({
        tagArr: [].concat(tagList),
      });
    } else {
      // getFileLabelId(this.state.dataId, id, this.state.userId).then(fileLabelId => {
      delelteFileLabel(id);
      // })
      let tagArr = [].concat(this.state.tagArr);
      let index = tagArr.findIndex((v) => {
        return v.lable_id === id;
      });
      tagArr.splice(index, 1);
      this.setState({
        tagArr: [].concat(tagArr),
      });
    }
  };
  handAdd = (tag) => {
    //检查是否已存在
    let index = this.state.tagArr.findIndex((v) => {
      return v.lable_content == tag;
    });
    if (index > -1) {
      this.setState({
        openMessage: true,
        errorMessage: "该标签已存在",
      });
      setTimeout(() => {
        this.closeMessage();
      }, 3000);
      return;
    }
    //获取标签id
    getLabelId(
      tag,
      this.state.userId,
      this.state.modalTitle == "管理订阅"
    ).then((labelId) => {
      if (this.state.modalTitle == "管理订阅") {
        // 新增订阅标签
        if (labelId) {
          addSubscribeLabel({
            lable: labelId,
            user: this.state.userId,
          }).then((resp) => {
            if (resp.id) {
              this.setState(
                {
                  tagArr: this.state.tagArr.concat([
                    {
                      lable_content: tag,
                      lable_id: labelId,
                    },
                  ]),
                  isFirst: true,
                },
                () => {
                  this.queryUserInfo();
                }
              );
            }
          });
        } else {
          this.setState({
            openMessage: true,
            errorMessage: "该标签不存在，无法订阅",
          });
        }
      } else {
        //打标签
        addLabelToFile({
          base_file: this.state.dataId,
          lable: labelId,
          lable_update_user: this.state.userId,
        }).then((resp) => {
          if (resp.id) {
            this.setState({
              tagArr: this.state.tagArr.concat([
                {
                  lable_content: tag,
                  lable_id: labelId,
                },
              ]),
            });
          }
        });
        //收藏标签
        addCollectLabel({
          lable: labelId,
          user: this.state.userId,
        });
      }
    });
  };

  //关闭消息弹框
  closeMessage = () => {
    this.setState({
      openMessage: false,
    });
  };


  showResult = () => {
    if (this.state.keyword == "") {
      if (this.state.count == 0) {
        return "没有该标签的订阅文件";
      } else return "没有了";
    } else {
      if (this.state.count == 0) {
        return "没有找到您想要的内容，请更换关键词";
      } else return "没有了";
    }
  };

  resetForm = () => {
    this.setState({
      form: {
        keyword: ''
      }
    })
  }

  searchForm = () => {
    this.loadMore()
  }

  onChangeForm = (value, key) => {
    let form = {
      ...this.state.form
    }
    form[key] = value
    this.setState({
      form: form
    })
  }

  changeTab = (data, i) => {
    this.setState(
      {
        fileType: data.type,
        tabIndex: i,
      },
      () => {
        this.getColumns()
        this.loadMore();
      }
    );
  }

  getCollectStatus = (id) => {
    let index = this.state.collectFileId.findIndex(v => {
      return v == id
    })
    return index > -1 ? '取消收藏' : '收藏'
  }

  getColumns = () => {
    let list = [
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 160,
        align: 'center',
        render: (text, row) => {
          return (
            <>
              {/* <Button type="text" className={this.props.classes.textBtn}>翻译</Button> */}
              <Button type="text" className={this.props.classes.textBtn} onClick={() => this.doCollect(row)}>
                {
                  this.getCollectStatus(row.base_file_id)
                }
              </Button>
              <Button className={this.props.classes.textBtn} type="text" onClick={() => this.downloadFile(row.dfs_url, row.file_name)}>下载</Button>
            </>
          )
        }
      },
      {
        title: '文件类型',
        dataIndex: 'file_category',
        key: 'file_category',
        width: 100,
        render: (text, row) => row.file_category
      },
      {
        title: '文件名称',
        dataIndex: 'file_name',
        key: 'file_name',
        width: 200,
        ellipsis: true,
        render: (_, row) => {
          let content = row.file_name || ''
          return   <Tooltip placement="topLeft" title={content}>
            <a target="_blank" className={this.props.classes.linkText} href={row.dfs_url}>{content}</a>
          </Tooltip>
        },
      },
      {
        title: '发布机构',
        dataIndex: 'medical_file_publish_orgnization',
        key: 'medical_file_publish_orgnization',
        width: 140,
      },
      {
        title: '发布时间',
        dataIndex: 'medical_file_publish_date',
        key: 'medical_file_publish_date',
        width: 110,
        render: (text, row) => {
          let data = row.medical_file_publish_date || ''
          return data.substring(0, 10)
        }
      },
      {
        title: '立法阶段',
        dataIndex: 'medical_file_law_status',
        key: 'medical_file_law_status',
        width: 100,
      },
  
      {
        title: '网页链接',
        dataIndex: 'medical_file_website_link',
        key: 'medical_file_website_link',
        width: 200,
        ellipsis: true,
        render: (_, row) => {
          let content = row.medical_file_website_link || ''
          return   <Tooltip placement="topLeft" title={content}>
            <a target="_blank" href={row.medical_file_website_link}>{content}</a>
          </Tooltip>
        },
      },
    ]
    if (this.state.fileType == '法规' ) {
      list.splice(6, 0, {
        title: '性质类型',
        dataIndex: 'regulation_file_type',
        key: 'regulation_file_type',
        width: 120,
      })
      this.setState({
        columns: list
      })
    } else if (this.state.fileType == '标准') {
      list.splice(6, 0, {
        title: '性质类型',
        dataIndex: 'standard_file_type',
        key: 'standard_file_type',
        width: 120,
      })
      this.setState({
        columns: list
      })
    } else  {
      this.setState({
        columns: list
      })
    }

  }

  pageChange = (page, pageSize) => {
    if (page == this.state.page.page && pageSize == this.state.page.pageSize) {
      return
    }
    this.setState({
      page: {
        page: page,
        pageSize: pageSize
      },
      loading: true
    }, () => this.loadMore())
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.loadMore();
      }
    );
  };

  //收藏、取消搜藏
  doCollect = (row) => {
    let isCollect = this.state.collectFileId.includes(
      row.base_file_id
    )
    if (isCollect) {
      confirm({
        title: '确认',
        content: '确认取消收藏？',
        onOk: () => {
          this.handCancelCollect(row.base_file_id)
        }
      })
    } else {
      this.handCollect(row.base_file_id)
    }
  }

  downloadFile = (url, fileName) => {
    axios({
      method: "get",
      url: url,
      responseType: "blob",
    }).then((resp) => {
      if (resp.status === 200) {
        if (window.navigator.msSaveOrOpenBlob) {
          let blob = resp.data;
          navigator.msSaveBlob(blob, fileName);
        } else {
          let blob = new Blob([resp.data], { type: "text" });
          let a = document.createElement("a");
          a.download = fileName;
          let URL = window.URL || window.webkitURL;
          a.href = URL.createObjectURL(blob);
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }
    });
  };

  changeSearchShow = () => {
    this.setState({
      showSearch: !this.state.showSearch,
      tourKey: this.state.tourKey + 1
    }, () => {
      setTimeout(() => {
        this.setState({
          tourKey: this.state.tourKey + 1
        })
      }, 350)
    })
  }

  
  changeTour = (current) => {
    this.setState({
      tourCurrent: current
    })
  }

  
  closeTour = () => {
    this.setState({
      openTour: false
    })
     // 更新新手指引状态
     editUserInfo({
      beginner_index: this.state.beginner_index + 4
    })
  }


  render() {
    const classes = this.props.classes;

    const steps = [
      {
        title: '',
        description: '根据您订阅的关键词，系统每日会将相关法规自动汇总到订阅中心',
        target: () => document.getElementById('my-subscribe'),
        placement: 'right'
      },
      {
        title: '',
        description: '点击可编辑、新增或删除订阅关键词',
        target: () => this.ref2.current,
        placement: 'left'
      },
      {
        title: '',
        description: '开启后，根据您订阅的关键词，系统每日会将相关法规列表推送到您绑定的邮箱',
        target: () => this.ref3.current,
        placement: 'left'
      },
      {
        title: '',
        description: '点击可收起/展开右侧关键词搜索模块',
        target: () => this.ref4.current,
        placement: 'left'
      },
    ];

    return (
      <div className={classes.root}>
        <div className={classes.topBar}>
          订阅中心
        </div>
        <div className={classes.main}>
          <div className={classes.leftTable}>
            <div className={['common-main-container', classes.tableOuter].join(' ')}>
              <div className={['main-top', classes.topTab].join(' ')}>
                <div>
                  {
                    this.state.showTab && 
                    this.state.tabList.map((v, i) => (
                      <span
                        key={i}
                        onClick={() => this.changeTab(v, i)}
                        className={[
                          "main-tab",
                          this.state.tabIndex == i ? "active" : "",
                        ].join(" ")}
                      >
                        {v.title}
                      </span>
                    ))
                  }
                </div>
                <div className={classes.slideIcon} style={{fontSize: 20, color: '#ccc'}} onClick={this.changeSearchShow} ref={this.ref4}>
                  {
                    this.state.showSearch ? 
                    <Tooltip title="收起关键词搜索">
                      <MenuUnfoldOutlined />
                    </Tooltip>
                      :
                    <Tooltip title="展开关键词搜索">
                      <MenuFoldOutlined />
                    </Tooltip>
                  }
                </div>
              </div>
              
              <div  className={classes.container} id="tableContainer">
                <Table 
                  className={classes.tableContainer}
                  columns={this.state.columns} 
                  loading={this.state.loading} 
                  dataSource={this.state.data} 
                  onChange={this.handleChange} 
                  pagination={this.state.paginationObj}
                  scroll={{x: 1230}}
                  bordered
                />
                
              </div>
            </div>
          </div> 
          <div className={[classes.rightForm, 'common-page', this.state.showSearch ? '' : classes.hideSearch].join(' ')}>
           
            <div className="common-left-search">
              <div className="left-search-title">
                <span className="search-title">关键词搜索</span>
                
              </div>
              <div className="search-form">
                <div className="form-item">
                  <div className="form-label">关键词</div>
                  <Input  value={this.state.form.keyword}
                    allowClear
                    onChange={(e) => this.onChangeForm(e.target.value, 'keyword')} 
                    placeholder="请输入关键词"/>
                </div>

                <div className={classes.labelContainer}>
                  <div className={classes.labelTitle}>
                    <div className={classes.titleLeft}>
                      <Button
                        onClick={this.showModal}
                        className={['default-btn', classes.clearMargin].join(' ')}
                        ref={this.ref2}
                      >
                        管理订阅
                      </Button>
                    </div>
                    <div className={classes.popover}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={this.state.push}
                            onChange={this.changePush}
                            name="push"
                            className={classes.switch}
                          />
                        }
                        label="邮件推送"
                        labelPlacement="start"
                        className={classes.switchLabel}
                        ref={this.ref3}
                      />
                    
                    </div>
                  </div>
                  <div className={classes.subTitle}>
                    全部订阅关键词
                  </div>
                  {this.state.allLabelList.map((item) => {
                    return (
                      <span
                        onClick={() => this.changeLabel(item.lable_content)}
                        key={item.lable_content}
                        className={[
                          classes.tag,
                          this.state.lable_content == item.lable_content ? "active" : "",
                        ].join(" ")}
                      >
                        {item.lable_content}
                        ({item.count})
                      </span>
                    );
                  })}
                </div>
              </div>

              <div className="search-bottom-btns">
                <Button className="default-btn" onClick={this.resetForm}>重置</Button>
                <Button className="primary-btn" onClick={this.searchForm}>搜索</Button>
              </div>
            </div>
          </div>
        </div>

        <Modal
          open={this.state.openModal}
          onClose={this.handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <LabelModal
              width={520}
              title={this.state.modalTitle}
              close={this.handleClose}
              tagArr={this.state.tagArr}
              handAdd={this.handAdd}
              handRemove={this.handRemove}
              dataId={this.state.dataId}
              parent_lable_id={this.state.parent_lable_id}
            />
          </div>
        </Modal>
        

        <Modal
          open={this.state.openSetting}
          onClose={this.handleCloseSetting}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <SettingModal
              width={520}
              title='邮件推送设置'
              close={this.handleCloseSetting}
              userEmail={this.state.userEmail}
              save={this.handleSavePushSetting}
            />
          </div>
        </Modal>
        <Tour key={this.state.tourKey} current={this.state.tourCurrent} onChange={this.changeTour} open={this.state.openTour}  closeIcon={false}  indicatorsRender={() => (<></>)} onFinish={this.closeTour} steps={steps} />
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(Subscribe));
